import { IStampDutyCountry } from "../forms/types";

export type IAdditionalChargeRuleFn = (propertyValue: number) => number;

export type IAdditionalChargeRule = [
  {
    country: IStampDutyCountry;
    isOnlyProperty: boolean;
  },
  IAdditionalChargeRuleFn
];

/**
 * https://revenue.scot/taxes/land-buildings-transaction-tax/additional-dwelling-supplement-ads
 */
const scotlandAdditionalProperty: IAdditionalChargeRule = [
  {
    country: IStampDutyCountry.SCOT,
    isOnlyProperty: false,
  },
  function calculateAdditionalDwellingSupplement(propertyValue: number) {
    if (propertyValue < 40_000) {
      return 0;
    }

    return 0.08 * (propertyValue);
  }
];

export const additionalChargeRules = [
  scotlandAdditionalProperty
];
